import React, { useState } from "react";
import { Alert, InfoCard } from "../../../../../components";

const InfoCardList = () => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  return (
    <div>
      <div className="grid grid-cols-6 gap-5 py-5">
        <InfoCard value={"50"} prefix={"Rs"} suffix={"Lakh"} />
        <InfoCard color="type2" value={500} suffix={"M"} />
        <InfoCard
          color="type3"
          value={124}
          action={() => setIsShowAlert(true)}
        />
        <InfoCard color="type4" value={500} />
      </div>
      <Alert
        isOpen={isShowAlert}
        onClose={() => setIsShowAlert(false)}
        title="Delete Item"
        description="Are you sure you want to delete this item? This action cannot be undone."
        cancelButton={{
          show: true,
          title: "Cancel",
          onClick: () => console.log("Cancelled"),
        }}
        acceptButton={{
          show: true,
          title: "Delete",
          onClick: () => console.log("Delete"),
        }}
      />
    </div>
  );
};

export default InfoCardList;
